// NOTE the generated observation and invers are both present in core and device, use of device in graph is erronous.

const upProperties = [
  'https://w3id.org/rec#isPartOf',
  'https://w3id.org/rec#locatedIn',
  'https://w3id.org/rec#leaseOf',
]

const downProperties = [
  'https://w3id.org/rec#includes',
  'https://w3id.org/rec#hasPart',
  'https://w3id.org/rec#isLocationOf',
  'https://w3id.org/rec#leasee',
]

export { upProperties, downProperties }
